import Plugin from '@ckeditor/ckeditor5-core/src/plugin'
import { AnchorEditing } from './AnchorEditing'
import { AnchorUI } from './AnchorUI'

export class Anchor extends Plugin {
  static get requires(): [typeof AnchorEditing, typeof AnchorUI] {
    return [AnchorEditing, AnchorUI]
  }

  static get pluginName(): string {
    return 'Anchor'
  }
}
